import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { LIGHT_BLUE, WHITE, APP_TEMA } from "../../styles/color";

export const QuickMenuContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  padding: 10px 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    gap: 8px;
    padding: 8px 10px;
  }
`;

export const MenuCategoryWrapper = styled.div`
  position: relative;
`;

export const CategoryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background-color: ${LIGHT_BLUE};
  color: ${WHITE};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #007acc;
  }

  @media (max-width: 576px) {
    padding: 6px 10px;
    font-size: 12px;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background-color: ${WHITE};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  z-index: 1000;
  overflow: hidden;
`;

export const DropdownItem = styled(Link)`
  display: block;
  padding: 10px 15px;
  text-decoration: none;
  color: #333;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${APP_TEMA};
    color: ${WHITE};
  }

  @media (max-width: 576px) {
    padding: 8px 12px;
    font-size: 13px;
  }
`;
